import type { NavItemProps } from 'src/components/nav-section';

import { useCallback } from 'react';

import { useSelectedTenant } from 'src/layouts/provider';
import { HQ_TENANT_ID, NAV_ROLE_HQ_ONLY } from 'src/constants/tenant-constant';

import { useAuthContext } from 'src/auth/hooks';

// ----------------------------------------------------------------------

/**
 * Dashboard 侧栏权限：按当前选中租户（tenantCode）与管理员身份过滤导航项
 */
export function useDashboardNavPermissions() {
  const { user } = useAuthContext();
  const { membership } = useSelectedTenant();

  const isHqTenant = membership?.tenantCode === HQ_TENANT_ID;

  return useCallback(
    (allowedRoles?: NavItemProps['allowedRoles']): boolean => {
      if (!allowedRoles?.length) return false;

      const roles = Array.isArray(allowedRoles) ? allowedRoles : [allowedRoles];

      if (roles.includes(NAV_ROLE_HQ_ONLY)) {
        return !isHqTenant;
      }

      const role = user?.isAdmin ? 'admin' : 'staff';
      return roles.includes(role);
    },
    [isHqTenant, user?.isAdmin]
  );
}
